import type { AnchorHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

/** An `<a target="_blank">` that tells screen-reader users it opens a new tab; works as a `Trans` component. */
export default function NewTabLink({
    children,
    ...props
}: AnchorHTMLAttributes<HTMLAnchorElement>) {
    const { t } = useTranslation('common');

    return (
        <a target="_blank" rel="noopener noreferrer" {...props}>
            {children}
            <span className="sr-only"> {t('opensInNewTab')}</span>
        </a>
    );
}
